import Typography from '@mui/material/Typography';
import { ITabPanelProps } from './types';

export const TabPanel = (props: ITabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      className={'w-full'}
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div className={'p-3'}>
          <Typography component={'span'}>{children}</Typography>
        </div>
      )}
    </div>
  );
};
